import { z } from 'zod/v4';
import { ToolCategory, ToolName, ToolNameSchema, ToolPolicy, ToolWeight, } from '../types.js';
const inputSchema = z.object({
    toolName: ToolNameSchema.describe('The name of the tool to inspect. Use search_tools first if you do not know which name applies.'),
});
const outputSchema = z.object({
    name: ToolNameSchema,
    category: z.enum(ToolCategory),
    weight: z.enum(ToolWeight),
    version: z.number().int(),
    description: z.string(),
    inputJsonSchema: z.record(z.string(), z.unknown()),
    outputJsonSchema: z.record(z.string(), z.unknown()),
});
export const getToolTool = {
    name: ToolName.GetTool,
    category: ToolCategory.Meta,
    weight: ToolWeight.Light,
    version: 1,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: 'Retrieve the full input schema and description for a tool, and expose it for invocation on your next turn. Use this before calling any tool you have not used in this run.',
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=get-tool.js.map